import * as React from "react";

import {Icon, Label, Table} from "semantic-ui-react";

import Dialog from "../../../components/Dialogs/Dialog";
import Button from "../../../components/Button";
import {Tab} from "semantic-ui-react";
import {MissingAssignmentsAndDerivateDTO} from "src/services/Client";
import {Background} from "ag-charts-community/dist/cjs/es5/chart/background";

interface IPSLandPCCDSyncDialogProps {
    result: MissingAssignmentsAndDerivateDTO;
    t: reactI18Next.TranslationFunction;
    onClose: () => void;
}

export const PSLandPCCDSyncDialog = (props: IPSLandPCCDSyncDialogProps) => {
    return (
        <Dialog
            title={props.t("OPTIONS_VIEW:CHECK_PSL_PCCD_SYNC_TT")}
            open={true}
            scrolling={false}
            actions={[
                <Button
                    key={"closeButton"}
                    icon={"ban"}
                    onClick={props.onClose}
                />
            ]}
        >
            <Tab
                panes={[
                    {
                        menuItem: props.t("OPTIONS_VIEW:TAB_PSL_PCCD_CHECK_INDEX_1"),
                        render: () => (
                            Object.keys(props.result.missingPCCDAssignments).length === 0 ?
                                <Label color='green' className='width--100Percent font-size--medium'>
                                    <Icon name='check circle' />
                                    {props.t("OPTIONS_VIEW:PSL_PCCD_COMPLETE")}
                                    <Label.Detail style={{verticalAlign: 'baseline'}}>{props.t("OPTIONS_VIEW:PSL_PCCD_COMPLETE_DTL")}</Label.Detail>
                                </Label>
                                :
                                <>
                                    <Label color='yellow' className='width--100Percent font-size--medium'>
                                        <Icon name='warning circle' />
                                        {props.t("OPTIONS_VIEW:PSL_PCCD_INCOMPLETE")}
                                        <Label.Detail style={{verticalAlign: 'baseline'}}>{props.t("OPTIONS_VIEW:PSL_PCCD_INCOMPLETE_DTL")}</Label.Detail>
                                    </Label>
                                    <Table
                                        celled={true}
                                        structured={true}
                                    >
                                        <Table.Header>
                                            <Table.Row>
                                                <Table.HeaderCell>{props.t("GLOBAL:BTYP")}</Table.HeaderCell>
                                                <Table.HeaderCell>{props.t("GLOBAL:OPTIONS")}</Table.HeaderCell>
                                            </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                            {Object.keys(props.result.missingPCCDAssignments).map((key: string, index: number) => {
                                                return (
                                                    <Table.Row key={'row-' + index}>
                                                        <Table.Cell>
                                                            <Label ribbon={true}>{key}</Label>
                                                        </Table.Cell>
                                                        <Table.Cell>{props.result.missingPCCDAssignments[key].join(', ')}</Table.Cell>
                                                    </Table.Row>
                                                );
                                            }
                                            )}
                                            {Object.keys(props.result.pccdNoDataAssignments)
                                                .filter((p) => props.result.pccdNoDataAssignments[p])
                                                .map((key: string, index: number) => {
                                                    return (
                                                        <Table.Row key={'row-' + index}>
                                                            <Table.Cell>
                                                                <Label ribbon={true} color="red">{key}</Label>
                                                            </Table.Cell>
                                                            <Table.Cell>No Options</Table.Cell>
                                                        </Table.Row>
                                                    );
                                                }
                                                )}
                                        </Table.Body>
                                    </Table>
                                </>
                        )
                    },
                    {
                        menuItem: props.t("OPTIONS_VIEW:TAB_PSL_PCCD_CHECK_INDEX_2"),
                        render: () => (
                            Object.keys(props.result.missingPCCDDerivates).length === 0 && !props.result.pccdNoDataDerivates ?
                                <Label color='green' className='width--100Percent font-size--medium'>
                                    <Icon name='check circle' />
                                    {props.t("OPTIONS_VIEW:PSL_PCCD_DERIVATE_COMPLETE")}
                                    <Label.Detail style={{verticalAlign: 'baseline'}}>{props.t("OPTIONS_VIEW:PSL_PCCD_COMPLETE_DTL")}</Label.Detail>
                                </Label>
                                : Object.keys(props.result.missingPCCDDerivates).length === 0 && props.result.pccdNoDataDerivates ?
                                    <Label color='red' className='width--100Percent font-size--medium'>
                                        <Icon name='warning sign' />
                                        <Label.Detail style={{verticalAlign: 'baseline', marginLeft: '-5px'}}>{props.t('BASEOPTIONS:OB_PCCD_NO_DATA_DTL')}</Label.Detail>
                                    </Label> :
                                    <>
                                        <Label color='yellow' className='width--100Percent font-size--medium'>
                                            <Icon name='warning circle' />
                                            {props.t("OPTIONS_VIEW:PSL_PCCD_DERIVATE_INCOMPLETE")}
                                            <Label.Detail style={{verticalAlign: 'baseline'}}>{props.t("OPTIONS_VIEW:PSL_PCCD_DERIVATE_INCOMPLETE_DTL")}</Label.Detail>
                                        </Label>
                                        <Table
                                            celled={true}
                                            structured={true}
                                        >
                                            <Table.Header>
                                                <Table.Row>
                                                    <Table.HeaderCell>{props.t("GLOBAL:BTYP")}</Table.HeaderCell>
                                                    <Table.HeaderCell>{props.t("GLOBAL:OPTIONS")}</Table.HeaderCell>
                                                </Table.Row>
                                            </Table.Header>
                                            <Table.Body>
                                                {Object.keys(props.result.missingPCCDDerivates).map((key: string, index: number) => {
                                                    return (
                                                        <Table.Row key={'row-' + index}>
                                                            <Table.Cell>
                                                                <Label ribbon={true}>{key}</Label>
                                                            </Table.Cell>
                                                            <Table.Cell>{props.result.missingPCCDDerivates[key].join(', ')}</Table.Cell>
                                                        </Table.Row>
                                                    );
                                                }
                                                )}
                                                {Object.keys(props.result.pccdNoDataDerivatesAssignments)
                                                    .filter((p: any) => props.result.pccdNoDataDerivatesAssignments[p])
                                                    .map((key: string, index: number) => {
                                                        return (
                                                            <Table.Row key={'row-' + index}>
                                                                <Table.Cell>
                                                                    <Label ribbon={true} color="red">{key}</Label>
                                                                </Table.Cell>
                                                                <Table.Cell>No Options</Table.Cell>
                                                            </Table.Row>
                                                        );
                                                    }
                                                    )}
                                            </Table.Body>
                                        </Table>
                                    </>
                        )
                    }
                ]}
            />
        </Dialog>
    );
};



// WEBPACK FOOTER //
// ./src/views/OptionsView/checkPSLandPCCDSync/PSLandPCCDSyncDialog.tsx